import { React, useEffect, useState } from 'react';
import Modal from '../../../../../../components/Modal';
import PropTypes from 'prop-types';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useGetPublicSetMutation } from '../../../../../../features/authentication/authApiSlice';

const PublicSetPreviewModal = ({
  viewPublicSetModal,
  viewPublicSetTitle,
  onClose,
  showPrintButton,
  selectedPublicAssignmentId
}) => {
  const [getAllPublicSet] = useGetPublicSetMutation();
  const [isWaiting, setIsWaiting] = useState(false);
  const [allPublicSet, setAllPublicSet] = useState([]);
   

  useEffect(() => {
    if(viewPublicSetModal)
      getAllPublicSets(selectedPublicAssignmentId);
  }, [viewPublicSetModal]);

  const getAllPublicSets = async (data) => {
    setIsWaiting(true);
    setAllPublicSet([]);
    const dataId = {
      assignmentId: data
    };
    const allPublicSetResponse = await getAllPublicSet(dataId).unwrap();
    setIsWaiting(false);
    setAllPublicSet(allPublicSetResponse);

    let updatedPublicSet = [];
    allPublicSetResponse.forEach((item) => {
      let resourceString = '';
      if (item.resources?.some((r) => !r.endsWith('.htm'))) {
        item.resources.forEach((path) => {
          let result = resourceViewHandlerFromUrl(path);
          resourceString = resourceString + result;
        });
      }
      updatedPublicSet.push({ ...item, updatedResources: resourceString });
    });
    setAllPublicSet(updatedPublicSet);
  };

  const resourceViewHandlerFromUrl = (value) => {
    let filetype = value.split('.').pop();
    let resource = '';
    switch (filetype) {
    case 'mp3':
      resource = ` <div className="resource-view d-flex justify-content-center">
      <audio controls>
        <source src=${value} type="audio/mpeg" />
      </audio>
    </div>`;
      break;

    case 'mp4':
      resource = ` <div className="resource-view d-flex justify-content-center">
      <video controls>
        <source src=${value} type="video/mp4" />
      </video>
    </div>`;
      break;

    case 'jpg':
    case 'gif':
    case 'bmp':
    case 'png':
      resource = ` <div className="resource-view d-flex justify-content-center">
      <img src=${value} classname="w-100" />
    </div>`;
      break;
    }
    return resource;
  };

  return (
    <Modal
      contentWidth="1200px"
      isOpen={viewPublicSetModal}
      titleName={`Assignment: ${viewPublicSetTitle}`}
      onClose={()=>onClose()}>
      {isWaiting ? (
        <div className="d-flex justify-content-center align-items-center h-40">
          <HesSpinner />
          <span className="ms-3">Loading results...</span>
        </div>
      ) : (
        <>
          <div className="assignment-properties">
            {allPublicSet.map((item, index) => (
              <div key={index} className="mb-4">
                <div className="d-flex align-items-start gap-3 questions-box">
                  <div>{index + 1}</div>
                  <div className="d-flex flex-column align-items-start ">
                    <div
                      className="bg-transparent border-0 border-bottom px-2 pb-1 mb-2"
                      dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                    <p dangerouslySetInnerHTML={{ __html: item.htmlContent }}></p>
                    <p dangerouslySetInnerHTML={{ __html: item.updatedResources }}></p>
                    {item.blockedText ? (
                      <p
                        dangerouslySetInnerHTML={{ __html: item.blockedText }}
                        className="fw-bold text-danger"></p>
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: item.question }}></p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {showPrintButton && (
            <div className="d-flex justify-content-end mt-3">
              <button disabled className="btn btn-castleRed print-btn">
                Print
              </button>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

PublicSetPreviewModal.propTypes = {
  viewPublicSetModal: PropTypes.bool,
  viewPublicSetTitle: PropTypes.string,
  onClose: PropTypes.func,
  showPrintButton: PropTypes.bool,
  selectedPublicAssignmentId: PropTypes.number
};

export default PublicSetPreviewModal;
